import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { createUser } from 'store/actions/user';
import { fetchReset } from 'store/actions/entities';
import CreateProfile from 'components/UserProfile/CreateProfile';

export default withTranslation()(
  connect(null, { createUser, fetchReset })(CreateProfile),
);
